import React, { useState } from "react";
import { MdEmail } from "react-icons/md";
import loginBg from "../../asset/login bg.png";
import logo from "../../asset/logo.svg";
import { toast } from "react-toastify";
import { useForgotPasswordMutation } from "../../redux/userApi";
import ButtonLoading from "../../Component/Button loading/ButtonLoading";
import { showErrorToast } from "../../utils/Utils";

const ForgotPassword = () => {
  const [email, setEmail] = useState();
  const [error, setError] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const validateForm = () => {
    let isValid = true;
    let newError = "";
    setError("");

    if (!email) {
      newError = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newError = "Please enter a valid email address.";
      isValid = false;
    }
    setError(newError);

    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return toast.error("Form validation failed.");
    }
    try {
      let response = null;
      response = await forgotPassword({ email: email }).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("users error:", err);
      showErrorToast(err);
    }
  };
  return (
    <div className=" w-full h-screen relative">
      <img src={loginBg} className="w-full h-full  object-fill" alt="" />
      <div className=" absolute h-screen bg-white p-8 2xl:w-[35%] xl:w-[38%] lg:w-[43%] md:w-[50%] sm:w-[65%] w-full top-0 right-0 sm:rounded-s-2xl flex flex-col gap-4 items-center justify-center">
        <img src={logo} className="w-28" alt="" />
        <span className="text-[1.8rem] text-center text-[#333333] font-semibold">
          Welcome BacK!
        </span>
        <span className="text-[1rem] text-center text-[#33333370]">
          Please enter the register email to reset password
        </span>
        <form className="flex flex-col gap-4 items-center justify-center w-[90%]">
          <div className=" flex flex-col gap-1 w-full">
            <div className="flex gap-3 w-full bg-transparent border p-3 rounded-full items-center text-[#33333390]">
              <MdEmail className=" size-6" />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError("");
                }}
                className="w-full bg-transparent outline-none rounded-none"
              />
            </div>
            {error && <p className="text-sm text-red-500">{error}</p>}
          </div>

          <button
            type="submit"
            onClick={handleSubmit}
            disabled={isLoading}
            className="w-full p-3 mt-10 bg-[#00643b] rounded-full font-medium disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center text-white"
          >
            {isLoading ? <ButtonLoading text="sending..." /> : "send"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
